import axios from 'axios'
import { auth, firebase, storage } from '../Firebase'
import { toast } from 'react-toastify';

let loadingToast = null

const ToastLoading = (msj) => {
  loadingToast = toast.info(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  })
}

const ToastSuccess = (msj) => {
  toast.success(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onOpen: () => {
      if (loadingToast !== null) {
        toast.dismiss(loadingToast)
      }
    },
  })
}

const ToastError = (msj) => {
  toast.error(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onOpen: () => {
      if (loadingToast !== null) {
        toast.dismiss(loadingToast)
      }
    },
  })
}

//constantes
const dataInicial = {
    loading: false,
    loadingSesion: false,
    activo: false,
    error: false,
    logoff: false,
    resultado: '',
    photoURL: null,
}

//Types auth/wrong-password
const LOADING = 'LOADING'
const LOADING_SESION = 'LOADING_SESION'
const USUARIO_ERROR = 'USUARIO_ERROR'
const USUARIO_EXITO = 'USUARIO_EXITO'
const CERRAR_SESION = 'CERRAR_SESION'
const USUARIO_ACTUALIZACION = 'USUARIO_ACTUALIZACION'
const LIMPIAR_ERROR = 'LIMPIAR_ERROR'
const LIMPIAR_ESTADO = 'LIMPIAR_ESTADO'

export default function usuariosReducer(state = dataInicial, action) {
    switch (action.type) {
        case USUARIO_ACTUALIZACION:
            return { ...state, empleadoid: action.empleadoid, usuarioPortalRh: action.usuarioPortalRh, photoURL: action.payload }
        case CERRAR_SESION:
            return { ...dataInicial }
        case USUARIO_EXITO:
            return { ...state, empleadoid: action.empleadoid, empleadoid: action.empleadoid, usuarioPortalRh: action.usuarioPortalRh, photoURL: action.photoURL }
        case USUARIO_ERROR:
            return { ...dataInicial, error: true, resultado: action.resultado, loadingSesion: action.loadingSesion }
        case LIMPIAR_ERROR:
            return { ...state, error: false }
        case LIMPIAR_ESTADO:
            return { ...state, logoff: true }
        case LOADING:
            return { ...state, resultado: action.resultado, loading: action.loading }
        case LOADING_SESION:
            return { ...state, resultado: action.resultado, loadingSesion: action.loadingSesion }
        default:
            return { ...state }
    }
}

export const cerrarSesion = () => async (dispatch) => {
    dispatch({
        type: LOADING
    })

    try {

        emptyCache()
        //Eliminamos el usuario del local storage
        localStorage.removeItem('usuario')
        //Cierra sesion en firestore
        dispatch({
            type: CERRAR_SESION
        })
        setTimeout(() => {
            auth.signOut()
        }, 500);
    } catch (error) {
        dispatch({
            type: USUARIO_ERROR
        })
    }
}

export const leerUsuarioActivo = () => (dispatch) => {
    if (localStorage.getItem('empleado')) {
        const user = JSON.parse(localStorage.getItem('empleado'))
        dispatch({
            type: USUARIO_EXITO,
            payload: user,
            empleadoid: user.empleadoid,
            usuarioPortalRh: user.usuarioPortalRh,
            photoURL: user.photoURL
        })
    }
}

function emptyCache() {
    if ('caches' in window) {
        caches.keys().then((names) => {
            // Delete all the cache files
            names.forEach(name => {
                caches.delete(name);
            })
        });

        // // Makes sure the page reloads. Changes are only visible after you refresh.
        // window.location.reload(true);
    }
}

export const actualizarAccountid = (uid) => async (dispatch) => {
    try {
        await firebase.collection('usuarios').doc(uid).get()
            .then((doc) => {
                //debugger;
                if (doc.exists) {
                    const documento = doc.data()
                    localStorage.setItem('photoURL', documento.photoURL);
                    dispatch({
                        type: USUARIO_ACTUALIZACION,
                        empleadoid: documento.empleadoid,
                        usuarioPortalRh: documento.usuarioPortalRh,
                        photoURL: documento.photoURL
                    })
                }
            })
    } catch (error) {
        dispatch({
            type: USUARIO_ERROR
        })
    }
}

export const limpiarError = () => (dispatch) => {
    dispatch({
        type: LIMPIAR_ERROR
    })
}

export const recuperarContraseña = (email) => async (dispatch) => {
    dispatch({
        type: LOADING
    })

    try {
        const resp = await auth.sendPasswordResetEmail(email)

    } catch (error) {
        dispatch({
            type: USUARIO_ERROR
        })
    }
}

export const LimpiarEstados = () => (dispatch) => {
    dispatch({
        type: LIMPIAR_ESTADO
    })
}

export const actualizarFotoUid = (imgEditada) => async (dispatch) => {
    dispatch({
        type: LOADING
    })
    ToastLoading("Procesando...")
    //uid
    const user = auth.currentUser;
    try {
        const imgRef = storage.ref().child(user.uid).child('foto perfil')
        await imgRef.put(imgEditada)
        const imgURL = await imgRef.getDownloadURL()

        const usuariosRef = firebase.collection('usuarios');
        const querySnapshot = await usuariosRef.where('uid', '==', user.uid).get();
        const userRef = querySnapshot.docs[0].ref;


        await userRef.update({
            photoURL: imgURL,
        })
            .then(() => {
                // Actualizar la propiedad photoURL en el objeto almacenado en el LocalStorage
                const empleado = JSON.parse(localStorage.getItem("empleado"));
                empleado.photoURL = imgURL;
                localStorage.setItem("empleado", JSON.stringify(empleado));
                
                toast.success('Foto subida con éxito!', {
                    theme: "dark",
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });


            }).catch((error) => {
                toast.error('Ocurrió un problema', {
                    theme: "dark",
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log(error)
            })

        dispatch({
            type: USUARIO_ACTUALIZACION,
            payload: imgURL
        })


    } catch (error) {
        console.log(error)
    }
}